import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h8l-4 16","key":"svg-0"}]]

const IconNumber7 = createReactComponent('outline', 'number-7', 'Number7', __iconNode);

export default IconNumber7;